export function deepEqual(a: Record<string, any>, b: Record<string, any>) {
	const aLength = Array.isArray(a) ? a.length : Object.keys(a).length;
	const bLength = Array.isArray(b) ? b.length : Object.keys(b).length;

	if (aLength !== bLength) {
		return false;
	}

	for (const [key, aValue] of Object.entries(a)) {
		const bValue = b[key];

		const aValueType = typeof aValue;
		const bValueType = typeof bValue;

		// If both values is objects - compare them props
		if (aValueType === 'object' && bValueType === 'object' && aValueType !== null && bValueType !== null) {
			if (!deepEqual(aValue, bValue)) {
				return false;
			} else {
				continue;
			}
		}

		// Compare as a simple type values
		if (!Object.is(aValue, bValue)) {
			return false;
		}
	}

	return true;
}
